import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import createModel from "@/__main__/data-model.mjs";

export const model = [
  {
    match_id: String,
    game_start: Number,
    game_duration: Number,
    players: [
      {
        puuid: String,
        game_name: String,
        tag_line: String,
        champion_id: Number,
      },
    ],
  },
] satisfies ModelDefinition;

const LeaderboardModel = createModel(model);

export type Leaderboard = FromModel<typeof LeaderboardModel>;

export default LeaderboardModel;
